import "regenerator-runtime";
// ** React Imports
import ReactDOM from "react-dom/client";

import { Suspense, lazy } from "react";
import { BrowserRouter } from "react-router-dom";

// ** Redux Imports
import { store } from "@store/store";
import { Provider } from "react-redux";

// ** ThemeColors Context

import { ThemeContext } from "./utility/context/ThemeColors";
// import { WellStatContext } from "./utility/context/wellstat";

// ** ThemeConfig
import themeConfig from "./configs/themeConfig";

// ** Toast
import { Toaster } from "react-hot-toast";

// ** i18n
import "./configs/i18n";

// ** Spinner (Splash Screen)
import Spinner from "./@core/components/spinner/Fallback-spinner";

// ** Ripple Button
import "./@core/components/ripple-button";

// ** PrismJS
import "prismjs";
import "prismjs/themes/prism-tomorrow.css";
import "prismjs/components/prism-jsx.min";

// ** React Perfect Scrollbar
import "react-perfect-scrollbar/dist/css/styles.css";

// ** React Hot Toast Styles
import "@styles/react/libs/react-hot-toasts/react-hot-toasts.scss";

// ** Core styles
import "./@core/assets/fonts/feather/iconfont.css";
import "./@core/scss/core.scss";
import "./assets/scss/style.scss";

// ** Service Worker
import * as serviceWorker from "./serviceWorker";

import { PersistGate } from "redux-persist/integration/react";
import { persistStore } from "redux-persist";

// setup Logging
import { logFilter, logAddFilter } from "@logging";
logAddFilter([
  // "onebuilding",
  // "BuildingInfo",
  // "appData::getDataPointsForSite",
  // "appData::getBuildingInfo",
  // "appData::getEnergyStarRatings",
  // "appData:getBuildingTableData",
  // "lookup",
  // "EXCEL",
  // "EXCELLOCAL",
  // "EIMS",
  // "EIMSEnergyOccupancy",
  // "UTILITYBILLS",
  // "ONEACCOUNT",
  // "IAQMS",
  // "datapointchart",
  // "HitzelTwin",
  // "login",
  // // "appData::getDatapointIntervalsForChart",
  // "PDF",
  // // "BuildingsList",
  // // "MapPage",
  // "BuildingStack",
  // // "WBRDataTab",
  // // "appData::getWellstatDevicesForSite",
  // // "OneUtility",
  // // "WBRDataTab",
  // "WBRDevicesTab",
  // // "WBRRegistersTab",
  // "EntireBuilding3D",
  // "OneFloor3D",
  // "MultiIAQMSSensorChart",
  // "WAQDataTab",
  // "WAQInfoTab",
  // "WAQDetail",
  // "OneGauge",
  // "Floor",
  // "WellStatDeviceManagement",
  // "WellStatDeviceManagementWAQ",
  // "WellStatDeviceManagementWBR",
  // "WellStatDeviceManagementPage",
  // "WellStatOTATransactions",
  // "Floor",
  // "Editor",
  // "WellStatFindDevices",
  // "DatapointsList",
  // "MultiDatapointChart",
  // "DataPage",
  // // "ColorWheel",
  // "BookmarkList",
  // "bookmarksslice",
  // "WellstatModbusRegisterTable",
  // "WellstatBacnetRegisterTable",
  // "UserOptions",
  // "SettingsPage",
  // "search",
  // "PORTFOLIOREPORT",

  // layout (buildingLayout)
  "useAccordion",
  "useBuildingLayout",
  "useSelectedData",
  "useTileMaps",
  "buildingLayoutSlice",
  "buildingLayout",
  "BuildingLayoutPage",
  // Twod
  "EquipmentCommissionForm",
  "FloorSelectionForm",
  "Editor2D",
  "Scene2D",
  "RegisterFloorForm",
  "TileMapMesh",
  // Threed
  "BuildingLayout3D",
  "Floor",
  "HVACLayout",
  "FiltersModalForm",
  "WBRtoWAQConnectionLines",
]); //, 'onebuilding', 'EIMS', 'NOOP'])
logFilter("general", "booting application");

const persistor = persistStore(store);

// ** Lazy load app
const LazyApp = lazy(() => import("./App"));
const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <BrowserRouter>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <Suspense fallback={<Spinner />}>
          <ThemeContext>
            {/* <WellStatContext> */}
            <LazyApp />
            <Toaster
              position={themeConfig.layout.toastPosition}
              toastOptions={{ className: "react-hot-toast" }}
            />
            {/* </WellStatContext> */}
          </ThemeContext>
        </Suspense>
      </PersistGate>
    </Provider>
  </BrowserRouter>,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
